module.exports = __webpack_public_path__ + "static/media/heste-forgot-pass.454b7b37.png";